import React, { useEffect, useState } from 'react';

import {
  Edit,
  SimpleForm,
  TextInput,
  // DateInput,
  FileInput,
  FileField,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { useParams } from 'react-router-dom';
import { supabaseClient } from './supabase';

const TicketEdit = (props) => {
  const [signedUrl, setSignedUrl] = useState(null);
  const [tempResource, setTempResource] = useState(null);
  const [theResource, setTheResource] = useState(null);
  const { id } = useParams();

  const getSignedUrl = async (file) => {
    if (file) {
      console.log(`Passed in file prop inside getSignedURL: ${file}`);
      try {
        const { data: media, error: mediaError } = await supabaseClient.storage
          .from('media')
          .createSignedUrl(`${file}`, 3600, { download: `${file}` });
        if (mediaError) throw new Error(mediaError.message);
        setSignedUrl(media.signedUrl);
        // return media.signedUrl;
      } catch (err) {
        console.log(`Caught error inside getSignedURL: ${err.message}`);
        setSignedUrl('');
        // return null;
      }
    } else {
      setSignedUrl('');
    }
  };
  const getResource = async (id) => {
    const { data: record, error } = await supabaseClient
      .from('tickets')
      .select(
        `
              id,
              title,
              description,
              attachment
          `
      )
      .match({ id: id })
      .single();
    if (error) throw new Error(`Error fetching the records: ${error.message}`);
    console.log(`record inside getResources: ${JSON.stringify(record)}`);
    setTempResource(record);
  };
  // const fetchSignedUrl = () => signedUrl;

  useEffect(() => {
    console.log(`id inside useEffect: ${id}`);
    getResource(id);
  }, [id]);
  useEffect(() => {
    if (tempResource) {
      getSignedUrl(tempResource.file);
    }
  }, [tempResource]);
  useEffect(() => {
    if (tempResource !== null) {
      setTheResource({
        ...tempResource,
        media: {
          title: tempResource.file,
          src: signedUrl,
        },
      });
    }
  }, [signedUrl, tempResource]);

  return (
    theResource && (
      <Edit {...props} title="Edit ticket" redirect="list">
        <SimpleForm record={theResource}>
          <TextInput source="title" />
          <RichTextInput source="description" />
          <FileInput
            label="Attachment"
            source="attachment"
            multiple={false}
            sx={{
              boxShadow: '0px 0px 6px 4px darkgrey',
              padding: '0px 8px',
              '& span': { fontSize: '1.75em', color: 'darkred' },
            }}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </SimpleForm>
      </Edit>
    )
  );
};

export default TicketEdit;
